import { render, staticRenderFns } from "./MAvatar.vue?vue&type=template&id=7b15bf97&"
import script from "./MAvatar.vue?vue&type=script&lang=ts&"
export * from "./MAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports